<template>
    <div style="height: 100%; overflow: auto">
        <b-card class="sa-card" header="Dettagli" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Setting</label>
                    <span class="sa-data">{{ jsonDataSettings.setting }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Codice</label>
                    <span class="sa-data">{{ jsonDataSettings.codice }}</span>
                </b-col>

                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Note</label>
                    <span class="sa-data">{{ jsonDataSettings.note }}</span>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    data() {
        return {
            pathResource: "/rsasettings",
            linkback: "/rsasettings",
            id: "",
            showModalLoading: false,
            jsonDataSettings: {},
            fieldset: {
                setting: "",
                codice: "",
                note: "",
            },
        };
    },

    /* watch: {
        jsonDataSettings: {
            handler(jsonDataSettings){
                this.$emit("jsonDataSettings", jsonDataSettings);
            },
            deep : true,
        },
    }, */

    mounted() {
        let me = this;
        me.id = this.$route.params.id;
        me.loadData();
    },

    methods: {
        loadData() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResource + "/" + me.id, null, me.loadSettingDataSuccess, me.loadSettingDataError);
        },
        loadSettingDataSuccess(response) {
            let me = this;
            me.jsonDataSettings = response.data.data;
        },
        loadSettingDataError() {
            let me = this;
            me.$bvToast.toast("Errore durante il caricamento dei dati:", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
    },
};
</script>
